import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/integrations/supabase/client";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router";
import { LoginLanguageSwitcher } from "@/components/LoginLanguageSwitcher";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const { t } = useTranslation();
  const [authError, setAuthError] = useState<string | null>(null);
  const navigate = useNavigate();
  
  // Check if user is already logged in and redirect if they are
  useEffect(() => {
    // Set up auth state listener
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      // When user is signed in, redirect to homepage
      if (event === 'USER_UPDATED' && session) {
        navigate('/', { replace: true });
      }
    });

    // Cleanup subscription on unmount
    return () => {
      subscription.unsubscribe();
      
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 relative">
      <LoginLanguageSwitcher />
      <div className="w-full max-w-md">
        <div className="bg-white p-8 rounded-lg shadow-lg border mb-6">
          {/* Logo at the top */}
          <div className="text-center mb-6">
            <img src="/tuties.png" alt="TUTIES" className="h-[3.25rem] mx-auto" />
          </div>
          
          {/* Sign in message */}
          <p className="text-center text-muted-foreground mb-6">
            {t('auth.resetMessage')}
          </p>
          
          {/* Error message */}
          {authError && (
            <div className="bg-destructive/10 border border-destructive text-destructive px-4 py-3 rounded-md mb-6">
              <p>{authError}</p>
            </div>
          )}
          <Auth
            supabaseClient={supabase}
            view="update_password"
            appearance={{
              theme: ThemeSupa,
              variables: {
                default: {
                  colors: {
                    brand: 'hsl(var(--primary))',
                    brandAccent: 'hsl(var(--primary))',
                  },
                  // Use valid properties for borderWidths and radii
                  borderWidths: {
                    buttonBorderWidth: '1px',
                    inputBorderWidth: '1px',
                  },
                  radii: {
                    buttonBorderRadius: '6px',
                    inputBorderRadius: '6px',
                  },
                },
              },
              // No custom class names to preserve default button colors
              className: {
                container: 'auth-container',
                divider: 'auth-divider',
                label: 'auth-label',
                input: 'auth-input',
                message: 'auth-message',
              },
            }}
            showLinks={false}
            localization={{
              variables: {

                update_password: {
                  password_input_placeholder: t('auth.newPasswordPlaceholder'),
                  password_label: t('auth.newPassword'),
                  button_label: t('auth.changePassword')
                }
              },
            }}
            
            providers={["google"]}
            // @ts-expect-error - onError exists in Auth component but TypeScript doesn't recognize it properly
            onError={(error) => {
              console.error('Supabase Auth Error:', error);
              
              // Handle auth errors
              if (error.message) {
                setAuthError(`Authentication error: ${error.message}`);
              }
            }}
            
            redirectTo={window.location.origin}
          />
        </div>
        <div className="text-center mt-4">
          {/* <p className="text-sm text-muted-foreground">
            {t('auth.noAccount')} <Link to="/register" className="text-primary hover:underline">{t('auth.createAccount')}</Link>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;